import { Court } from "./court.model";
import { CaseType } from "./case-type.model";
import { CaseCategory } from "./case-category.model";
import { ZipCode } from "./zip-code.model";
import { JtiDocument } from "./document-filing.model";
import { jurisAmount } from "./juris-amount.model";
import { PartyDTO } from "./PartyDTO.model";
import { JtiAdditionalAddress } from "./jti-additional-address.model";
import { extend } from "webdriver-js-extender";
import { Attorney } from "./attorney.model";
import { JtiDocumentWithAdditionalDataDTO } from "./jti-document-with-additional-data.model";
import { ConditionallySealed } from "./conditionally-sealed-model";
import { FicticiousParty } from "./ficticious-PartyName.model";
import { CreditCard } from "./credit-card.model";
import { AchAccount } from "./ach-account.model";
import { subsequentParty } from './Subsequent-party.model';
import { DocumentFilingMetaDataItem } from './jti-document-additional-info.model';
import { State } from './state-list.model';

export class NewFiling {
  jtiOrderNumber: number;
  selectedState: State;
  selectedCourt: Court;
  selectedCaseType: CaseType;
  selectedCaseCategory: CaseCategory;
  selectedZipCode: ZipCode;
  selectedJurisAmount: jurisAmount;
  demandAmount: string;
  jtiDocuments: JtiDocument[];
  feeWaiverDocuments: JtiDocument[];
  partyByList: PartyDTO[];
  partyToList: PartyDTO[];
  partyNotAsToList:PartyDTO[];
  partyList: PartyDTO[];
  ficticiousPartyList: FicticiousParty[];
  ficticiousPartyListAsTo: FicticiousParty[];
  ficticiousParty: FicticiousParty;
  attorneyList: Attorney[];
  feewaiveDoc:JtiDocument[];
  clientCode: string;
  matterNumber: string;
  messageToClerk: string;
  subsequentPart: subsequentParty[];
  selectedDocumentList:JtiDocument[];
  // additional fields in table
  orderNumber: number;
  thisIsANewCase: boolean;
  caseTitle: string;
  caseTrackingID: string;
  caseNumber: string;
  firstComplaintID: string;
  filingAttorneyCode: string;
  ownedBy: string;
  jurisAmountCode: string;
  citationIdentification: string;
  noFeeSection: string;
  filingAttorneyEmail: string;
  confirmationNumber: string;
  courtFirmGuid: string;
  courtUserGuid: string;
  statusCode: string;
  customerCode: string;
  clientReference: string;
  attorneyCaseParticipantID: string;
  conciergeCustomerCode: string;
  parentLocationName: string;
  dateTimeFiled: Date;
  citationDate: Date;
  dateTimeDeleted: Date;
  dateTimeReceived: Date;
  callbackEmailSent: Date;
  amountInControversy: number;
  numberOfParcels: number;
  filingAttorneyVerb: number;
  caseIsConfidential: boolean;
  feeWaiverAppliesToThisOrder: boolean;
  noFeeCase: boolean;
  governmentAgencyFeeWaiver: boolean;
  filingAttorneyHasChanged: boolean;
  submittedDocumentsCanBeDeleted: boolean;
  feePaid: boolean;
  conditionallySealed: boolean;
  deliverCourtesyCopy: boolean;
  seletedMetaDataItem:DocumentFilingMetaDataItem;
  // foreign key fields
  premiseAddress: JtiAdditionalAddress;
  incidentAddress: JtiAdditionalAddress;
  userOrganizationId:string;
  alnUserId: string;
  emailAddress:string;
  isCheckedCovid:boolean;
  feeWaiverDocStNumber: number = 100;
  isComplexLitigation: boolean|null;
  get completedJtiDocuments(): JtiDocument[]{
    if (!this.jtiDocuments) { return this.jtiDocuments; }
    return this.jtiDocuments.filter(jd => !!jd.documentCode && !!jd.fileName);
  }

  toModelForSubmit(): NewFilingForSubmit {
    const newFilingForSubmit: NewFilingForSubmit = new NewFilingForSubmit();
    Object.assign(newFilingForSubmit, this);
    newFilingForSubmit.courtLocationCode = this.selectedCourt.code;
    newFilingForSubmit.caseCategoryCode = this.selectedCaseCategory.code;
    newFilingForSubmit.caseTypeCode = this.selectedCaseType.code;
    newFilingForSubmit.zipCode = this.selectedZipCode.zipCode;
    newFilingForSubmit.locationCode = this.selectedZipCode.locationCode;
    newFilingForSubmit.locationName = this.selectedZipCode.locationName;
    newFilingForSubmit.documents = newFilingForSubmit.completedJtiDocuments;
    newFilingForSubmit.parties = this.partyByList.concat(this.partyToList);
    if (this.ficticiousPartyList) {
      for (let p = 0; p <= newFilingForSubmit.parties.length - 1; p++) {
        const party = newFilingForSubmit.parties[p];
        if (this.ficticiousPartyList.filter(fp => fp.orderNumber == party.orderNumber && fp.partyNumber == party.partyNumber).length > 0)
        {
          newFilingForSubmit.parties[p].ficticiousPartyNames = this.ficticiousPartyList.filter(fp => fp.orderNumber == party.orderNumber && fp.partyNumber == party.partyNumber);
        }
      }
    }
    if (this.feewaiveDoc) {
      if(!newFilingForSubmit.parties[0].jtiPartyDocuments)      
      for (let p = 0; p <= newFilingForSubmit.parties.length - 1; p++) {       
        const party = newFilingForSubmit.parties[p];
        if(party.feeWaiver==true){
          newFilingForSubmit.parties[p].jtiPartyDocuments=[];
        newFilingForSubmit.parties[p].jtiPartyDocuments[p] = this.feewaiveDoc[p];
        }
      }
    }
    newFilingForSubmit.jurisAmountCode = this.selectedJurisAmount ? this.selectedJurisAmount.code : '';
    newFilingForSubmit.filingAttorney = (!this.attorneyList || this.attorneyList.length == 0) ? null : this.attorneyList ;
    return newFilingForSubmit;
  }
  
}


export class NewFilingForSubmit extends NewFiling {
  courtLocationCode: string;
  caseCategoryCode: string;
  caseTypeCode: string;
  zipCode: string;
  locationCode: string;
  locationName: string;
  documents: JtiDocument[];
  feeWaiverDocuments: JtiDocument[];
  parties: PartyDTO[] = [];
  filingAttorney: Attorney[];
  conditionallySealed: boolean;
  creditCard: CreditCard;
  achAccount: AchAccount;
  conciergeId?: number;
}

export class SubsequentFiling extends NewFiling{
  jtiDocumentWithAdditionalDataDTO: JtiDocumentWithAdditionalDataDTO[];

}

export class SubsequentFilingForSubmit extends SubsequentFiling {
  courtLocationCode: string;
  caseCategoryCode: string;
  caseTypeCode: string;
  zipCode: string;
  locationCode: string;
  locationName: string;
  documentsWithAdditionalData: JtiDocumentWithAdditionalDataDTO[];
  creditCard: CreditCard;
  achAccount: AchAccount;
  courtName:string;
  conciergeId?: number
}
